import { useParamsContext } from '../../contexts/ParamsContext';
import DashboardFinanceiro from './DashboardFinanceiro';
import Receber from './Receber';
import Pagar from './Pagar';
import Dre from './Dre';
import FluxoCaixa from './FluxoCaixa';
import AssinaturasFinanceiro from './AssinaturasFinanceiro';
import Configuracoes from './Configuracoes';

export default function Financeiro() {
    const { action, setParams } = useParamsContext();
    const current = action || 'dashboard';

    return (
        <div className="flex flex-col gap-4">
            <div className="card bg-base-100 shadow">
                <div className="card-body py-3">
                    <div className="flex flex-wrap gap-2">
                        <button
                            className={`btn btn-sm ${current === 'dashboard' ? 'btn-primary' : 'btn-ghost'}`}
                            onClick={() => setParams({ action: 'dashboard', id: '' })}
                        >
                            Dashboard
                        </button>
                        <button
                            className={`btn btn-sm ${current === 'receber' ? 'btn-primary' : 'btn-ghost'}`}
                            onClick={() => setParams({ action: 'receber', id: '' })}
                        >
                            Receber
                        </button>
                        <button
                            className={`btn btn-sm ${current === 'pagar' ? 'btn-primary' : 'btn-ghost'}`}
                            onClick={() => setParams({ action: 'pagar', id: '' })}
                        >
                            Pagar
                        </button>
                        <button
                            className={`btn btn-sm ${current === 'dre' ? 'btn-primary' : 'btn-ghost'}`}
                            onClick={() => setParams({ action: 'dre', id: '' })}
                        >
                            DRE
                        </button>
                        <button
                            className={`btn btn-sm ${current === 'fluxo-caixa' ? 'btn-primary' : 'btn-ghost'}`}
                            onClick={() => setParams({ action: 'fluxo-caixa', id: '' })}
                        >
                            Fluxo de caixa
                        </button>
                        <button
                            className={`btn btn-sm ${current === 'assinaturas' ? 'btn-primary' : 'btn-ghost'}`}
                            onClick={() => setParams({ action: 'assinaturas', id: '' })}
                        >
                            Assinaturas
                        </button>
                        <button
                            className={`btn btn-sm ${current === 'configuracoes' ? 'btn-primary' : 'btn-ghost'}`}
                            onClick={() => setParams({ action: 'configuracoes', id: '' })}
                        >
                            Configurações
                        </button>
                    </div>
                </div>
            </div>

            {current === 'receber' ? (
                <Receber />
            ) : current === 'pagar' ? (
                <Pagar />
            ) : current === 'dre' ? (
                <Dre />
            ) : current === 'fluxo-caixa' ? (
                <FluxoCaixa />
            ) : current === 'assinaturas' ? (
                <AssinaturasFinanceiro />
            ) : current === 'configuracoes' ? (
                <Configuracoes />
            ) : (
                <DashboardFinanceiro />
            )}
        </div>
    );
}

